<template>
<div>
    <h6>{{$t('SEND_NEWS.Toolbar_Size')}}</h6>
    <b-button-group class="btn-group-size-zoom">
        <b-button variant="outline-primary" @click="changeToDefault" :class="{'selected': isDefaultSelected}">
        -A
        </b-button>
        <b-button variant="outline-primary" @click="changeToMedium" :class="{'selected': isMediumSelected}">
        A
        </b-button>
        <b-button variant="outline-primary" @click="changeToBig" :class="{'selected': isBigSelected}">
        A+
        </b-button>
    </b-button-group>
</div>
</template>

<script>
import { BButton, BButtonGroup } from "bootstrap-vue";
import AppConstants from '@/appConstants';
export default {
    components: {
        BButton, 
        BButtonGroup
    },
    computed: {
        currentZoom() {
            return this.$store.state.auth.currentUser.zoom;
        },
        isDefaultSelected() {
            return this.currentZoom == AppConstants.ZOOM_DEFAULT;
        },
        isMediumSelected() {
            return this.currentZoom == AppConstants.ZOOM_MEDIUM;
        },
        isBigSelected() {
            return this.currentZoom == AppConstants.ZOOM_BIG;
        },
    },
    methods: {
        changeToDefault() {
            this.$store.dispatch('auth/updateZoom', AppConstants.ZOOM_DEFAULT);
        },
        changeToMedium() {
            this.$store.dispatch('auth/updateZoom', AppConstants.ZOOM_MEDIUM);
        },
        changeToBig() {
            this.$store.dispatch('auth/updateZoom', AppConstants.ZOOM_BIG);
        },
    }
};
</script>

<style>
</style>